let timelineElements = [
	{
		id: 1,
		title: "Full-Stack Developer",
		location: "Visakhapatnam (Remote)",
		description:
			"Delivering scalable web applications using the MERN stack for 5+ clients across healthcare and media sectors.",
		buttonText: "View Project",
		buttonHref: "https://daily-physio.vercel.app/",
		date: "May 2025 - Ongoing",
		icon: "work",
	},
	{
		id: 2,
		title: "Jr Software Engineer",
		location: "VTS Enterprises Pvt Ltd, Chennai (On-site)",
		description:
			"Worked in a collaborative environment, focusing on full-stack development, system integration, and project management, while enhancing problem-solving and communication skills.",
		buttonText: "View Certificate",
		buttonHref: "https://res.cloudinary.com/ddgmxrhku/image/upload/v1756406341/VTS2025051_G_V_S_Ravi_Kiran_Varma_EXPERIENCE_LETTER_jf7x7l.pdf",
		date: "June 2024 - June 2025",
		icon: "work",
	},
	{
		id: 3,
		title: "AWS DevOps Intern",
		location: "ArchaeoByte, Hyderabad (Remote)",
		description:
			"Automated web app deployments using AWS, Jenkins, and GitHub, enhancing deployment efficiency and real-time updates.",
		buttonText: "View Certificate",
		buttonHref: "https://res.cloudinary.com/dalzs7bc2/image/upload/v1742632832/coc_lpmqfj.pdf",
		date: "Oct - Nov 2023",
		icon: "work",
	},
	{
		id: 4,
		title: "Azure Cloud Intern",
		location: "Academor, Bengaluru (Remote)",
		description:
			"Worked on cloud computing projects including virtualization, load balancing, data migration, and web hosting, earning a co-branded certification.",
		buttonText: "View Certificate",
		buttonHref: "https://res.cloudinary.com/dalzs7bc2/image/upload/v1742632816/post_rmxccs.pdf",
		date: "Sept - Nov 2023",
		icon: "work",
	},
	{
		id: 5,
		title: "Hybrid Cloud Intern",
		location: "LinuxWorld Informatics Pvt Ltd, Jaipur (On-site)",
		description:
			"Acquired expertise in AWS, Red Hat Linux, Python, Docker, Kubernetes, Jenkins, and generative AI while developing essential soft skills.",
		buttonText: "View Certificate",
		buttonHref: "https://res.cloudinary.com/dalzs7bc2/image/upload/v1742633631/Training_compressed_c7i7kf.pdf",
		date: "June - Aug 2023",
		icon: "work",
	},
	{
		id: 6,
		title: "Bachelor of Technology in Computer Science Engineering",
		location: "MVGR College of Engineering, Vizianagaram, AP",
		description:
			"Graduated with a CGPA of 8.98, specializing in Computer Science and Engineering.",
		buttonText: "View Degree",
		buttonHref: "https://res.cloudinary.com/dalzs7bc2/image/upload/v1742632999/PC_yrrifb.pdf",
		date: "2020 - 2024",
		icon: "school",
	},
	{
		id: 7,
		title: "Intermediate - MPC",
		location: "Sri Venkateshwara Junior College, Visakhapatnam, AP",
		description:
			"Studied Mathematics, Physics, Chemistry, and English with a CGPA of 9.42.",
		buttonText: "View Certificate",
		buttonHref: "https://res.cloudinary.com/dalzs7bc2/image/upload/v1742632999/PC_yrrifb.pdf",
		date: "2018 - 2020",
		icon: "school",
	},
	{
		id: 8,
		title: "High School Education",
		location: "MP & EV English Medium School, Visakhapatnam, AP",
		description:
			"Completed high school with subjects including Mathematics, Science, Social Studies, Telugu, and English",
		buttonText: "View Certificate",
		buttonHref: "https://res.cloudinary.com/dalzs7bc2/image/upload/v1742632999/PC_yrrifb.pdf",
		date: "2017 - 2018",
		icon: "school",
	},
];

export default timelineElements;
